#!/usr/bin/env node

import { upload } from './push-client.js';

await upload();
